import * as helpers from 'app/sm/helpers'
import * as textHelpers from 'app/utils/text/helpers'

export const applicationWorkflowStages = {
  onlist_incomplete: 'onlist_incomplete',
  archived: 'archived',
  new: 'new',
  processing: 'processing',
  requested_info: 'requested_info',
  shortlisted: 'shortlisted',
  withdrawn: 'Withdrawn',
  pre_approval: 'pre_approval',
  with_owner: 'with_owner',
  owner_approved: 'owner_approved',
  application_approved: 'application_approved',
  offered: 'offered',
  payment_pending: 'payment_pending',
  deposit_received: 'deposit_received',
  accepted: 'accepted',
  lease_sent: 'lease_sent',
  mark_as_leased: 'mark_as_leased',
}

export const applicationWorkflowGeneralStages = {
  onlist_incomplete: 'onlist_incomplete',
  archived: 'archived',
  new: 'new',
}

export const applicationWorkflowReviewStages = {
  processing: 'processing',
  requested_info: 'requested_info',
  shortlisted: 'shortlisted',
  withdrawn: 'Withdrawn',
}

export const applicationWorkflowApproveStages = {
  pre_approval: 'pre_approval',
  with_owner: 'with_owner',
  owner_approved: 'owner_approved',
  application_approved: 'application_approved',
}

export const applicationWorkflowOfferStages = {
  offered: 'offered',
  payment_pending: 'payment_pending',
  deposit_received: 'deposit_received',
}

export const applicationWorkflowAcceptStages = {
  accepted: 'accepted',
  lease_sent: 'lease_sent',
  mark_as_leased: 'mark_as_leased',
}

export const applicationWorkflowStageConfig = {
  [applicationWorkflowStages.onlist_incomplete]: {
    title: textHelpers.ONLIST_INCOMPLETE_TEXT,
    value: textHelpers.ONLIST_INCOMPLETE,
  },
  [applicationWorkflowStages.archived]: {
    title: 'Archived',
    value: textHelpers.ARCHIVED_STATUS,
  },
  [applicationWorkflowStages.new]: {
    title: 'New',
    value: 1,
  },

  [applicationWorkflowReviewStages.processing]: {
    title: 'Processing',
    value: 9,
  },
  [applicationWorkflowReviewStages.requested_info]: {
    title: 'Requested info',
    value: 10,
  },
  [applicationWorkflowReviewStages.shortlisted]: {
    title: 'Shortlisted',
    value: 2,
  },
  [applicationWorkflowReviewStages.withdrawn]: {
    title: 'Withdrawn',
    value: 15,
  },

  [applicationWorkflowApproveStages.pre_approval]: {
    title: 'Pre-approval / With PM',
    value: 11,
  },
  [applicationWorkflowApproveStages.with_owner]: {
    title: 'With Owner',
    value: 19,
  },
  [applicationWorkflowApproveStages.owner_approved]: {
    title: 'Owner approved',
    value: 12,
  },
  [applicationWorkflowApproveStages.application_approved]: {
    title: 'Application approved',
    value: 17,
  },

  [applicationWorkflowOfferStages.offered]: {
    title: 'Offered',
    value: 3,
  },
  [applicationWorkflowOfferStages.payment_pending]: {
    title: 'Payment pending',
    value: 13,
  },
  [applicationWorkflowOfferStages.deposit_received]: {
    title: 'Deposit received',
    value: 18,
  },

  [applicationWorkflowAcceptStages.accepted]: {
    title: 'Accepted',
    value: 6,
  },
  [applicationWorkflowAcceptStages.lease_sent]: {
    title: 'Lease sent',
    value: 14,
  },
  [applicationWorkflowAcceptStages.mark_as_leased]: {
    title: 'Mark as leased',
    value: 7,
  },
}

export const workflowsOptions = Object.values(applicationWorkflowStages).map(
  (workflow) => ({
    option: workflow,
    optionMeta: {
      id: workflow,
      displayText: applicationWorkflowStageConfig[workflow]?.title,
      noSeparator: true,
      value: applicationWorkflowStageConfig[workflow]?.value,
    },
  }),
)

export const agencySortType = {
  viewing: 'viewing',
  applications: 'applications',
}

export const agencySortFilterIds = {
  properties: 'properties',
  date: 'date',
  status: 'status',
}

export const getViewingSortConfig = (type: string, teamSlug: string) => {
  switch (type) {
    case agencySortType.viewing:
      return {
        [agencySortFilterIds.properties]: {
          title: 'Properties',
          value: helpers.urlTo('teamsViewing', { teamSlug }),
          id: agencySortFilterIds.properties,
        },
        [agencySortFilterIds.date]: {
          title: 'Date',
          value: helpers.urlTo('teamViewingsByDate', { teamSlug }),
          id: agencySortFilterIds.date,
        },
      }
    case agencySortType.applications:
      return {
        [agencySortFilterIds.properties]: {
          title: 'Properties',
          value: helpers.urlTo('teamsApplication', { teamSlug }),
          id: agencySortFilterIds.properties,
        },
        [agencySortFilterIds.status]: {
          title: 'Status',
          value: helpers.urlTo('teamApplicationsByStage', { teamSlug }),
          id: agencySortFilterIds.status,
        },
      }

    default:
      return {}
  }
}
